import React from 'react';
import Helmet from 'react-helmet';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

const Protocol = () => {
  const title = '用户隐私条款 - 魔鬼鱼订货平台';
  const pageDescription = '魔鬼鱼（上海）网络科技有限公司用户隐私条款，保护用户个人信息安全。';

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.mantas.cn'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '用户隐私条款',
        item: 'https://www.mantas.cn/protocol'
      }
    ]
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '用户隐私条款',
    description: '魔鬼鱼（上海）网络科技有限公司用户隐私条款',
    specialty: 'LegalService'
  };

  return (
    <Layout>
      <SEO title={title} description={pageDescription} path="/protocol" />
      <Helmet>
        <meta
          name="keywords"
          content="魔鬼鱼隐私条款, 用户协议, 个人信息保护, 魔鬼鱼用户协议"
        />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no"
        />
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbLd)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>
      </Helmet>
      <article className="protocol_container">
        <h1 className="protocol_container__header">魔鬼鱼（上海）网络科技有限公司用户隐私条款</h1>
        <div className="protocol_container__content">
          <p>
            重要须知：魔鬼鱼（上海）网络科技有限公司（下称“魔鬼鱼（上海）网络科技有限公司”）在此特别提醒您仔细阅读本《魔鬼鱼（上海）网络科技有限公司网站用户协议》（下称“本协议”）中的各个条款，包括但不限于免除或者限制魔鬼鱼（上海）网络科技有限公司责任的条款、对用户权利进行限制的条款以及约定争议解决方式、司法管辖的条款。您有权选择同意或者不同意本协议。
            <br />
            您如果通过登录魔鬼鱼（上海）网络科技有限公司网站或“魔鬼鱼”手机端应用的用户注册页面或魔鬼鱼（上海）网络科技有限公司提供的其他用户注册渠道注册用户账号，即视为您完全同意本协议，愿意接受本协议所有及任何条款的约束。
          </p>

          <br />
          <h2>1.名词解释</h2>
          <p>除您与魔鬼鱼（上海）网络科技有限公司另有约定外，本协议及其补充协议当中的下列名词均采用如下解释：</p>
          <p>1.1 魔鬼鱼（上海）网络科技有限公司网站用户协议：即本协议，指您与魔鬼鱼（上海）网络科技有限公司当下订立的旨在约定您登录、使用本网站，以及通过本网站下达订单、购买商品、支付货款、收取商品等整个网购过程中，您与魔鬼鱼（上海）网络科技有限公司之间的权利、义务的书面合同。</p>
          <p>1.2 魔鬼鱼（上海）网络科技有限公司网站：即本网站，指魔鬼鱼（上海）网络科技有限公司享有全部著作权的、提供给您及其他用户登录和使用的网站。</p>
          <p>1.3 商品：是魔鬼鱼（上海）网络科技有限公司通过本网站向您推荐并进行销售的具体商品的统称。</p>
          <p>1.4 品牌供应商：与魔鬼鱼（上海）网络科技有限公司签订协议，组织商业活动并通过本网站销售商品和服务的公司，包括品牌供应商或者其授权的经销商。</p>
          <p>1.5 购物车：是模拟线下实体商店提供给顾客放置商品的“购物车”的一个概念，指本网站向您展示您已经下达订单、准备购买但尚未支付相应的购买价款的商品信息的网页区域， 又称“虚拟购物车”。</p>
          <p>1.6 订单：指由本网站结帐程序生成的记录会员通过本网站所购买的商品的名称、品牌、价款、折扣等交易信息的表格。这份文件将被用作所有可能发生的与会员购买有关的询问、请求和争议的参考。</p>
          <p>1.7 送货单：指魔鬼鱼（上海）网络科技有限公司或者其品牌供应商、授权的经销商附录在会员所订购的商品的包裹上的、供会员签收的商品销售凭证，送货单一般会简要地说明了对应包裹的每一件商品的名称和数量，如发生退换货必须寄回。</p>
          <p>1.8 送货地址：指您或者其他用户通过本网站购买商品所要求的送货地址，如果没有特别说明，即为会员填写的订单上所记载的送货地址。</p>
          <p>1.9 用户账号：指您通过登录本网站或者魔鬼鱼（上海）网络科技有限公司提供其他的用户账号注册渠道，注册获得并可据以登录本网站的账号。</p>
          <p>1.10 恶意评论：是指个人或组织对本网站、魔鬼鱼（上海）网络科技有限公司和/或本网站对外销售的商品没有兴趣，却组织人力或者采用计算机程序模拟正常用户在本网站上大规模发表用户评论，特别发表对本网站、魔鬼鱼（上海）网络科技有限公司和/或本网站销售的商品负面的评论乃至违反国家有关法律法规的评论。</p>

          <br />
          <h2>2.合同目的</h2>
          <p>本协议旨在约定您在登录、使用本网站，通过本网站购买商品的过程中，您与魔鬼鱼（上海）网络科技有限公司双方分别作为本协议的一方合同当事人所享有的权利和所负有的义务。</p>

          <br />
          <h2>3.用户账号</h2>
          <p>3.1 您可以通过登录本网站的用户账号注册页面注册用户账号并设置相应的登录密码，一经注册成功，您即可以凭借用户账号及登录密码登录及使用本网站。就目前而言，上述用户账号既可能是您的移动电话号码，也可能是您的个人邮箱账号。</p>
          <p>3.2 您成功注册用户账号后，如果需要使用该用户账号从本网站购买商品的，至少还应当填写一个收货人、收货地址和手机号码。除此之外，您还可以按照本网站相关页面的说明填写该用户账号项下的用户姓名、性别、生日、移动电话、固定电话、所在地地址、个人邮箱、婚姻状况、体重以及身高等个人信息，上述个人信息仅作为完善您的用户账号资料之用，是否填写并不影响您从本网站购买商品。</p>
          <p>3.3 每个手机号码、每个收货地址仅对应一个会员账户。 包含但不限于以下行为，视为虚假注册：</p>
          <p>（1）以同一手机号码注册多个账户；</p>
          <p>（2）多个账户使用同一收货地址或同一IP地址；</p>
          <p>魔鬼鱼（上海）网络科技有限公司有权取消虚假注册账户在魔鬼鱼（上海）网络科技有限公司网站上消费的权利。</p>
          <p>3.4 您务必妥善保管您的用户账号、登录密码、支付密码（如有）及您在其项下填写的所有个人信息，不得将其赠与、转让、借用或者以其他的方式提供给第三方。否则，由此给您（或魔鬼鱼（上海）网络科技有限公司、任何第三方）造成的一切损失，概由您自行承担（或者负责赔偿），包括但不限于：</p>
          <p>（1）您无法凭借该用户账号登录、使用本网站及/或从本网站购买商品；</p>
          <p>（2）您的该用户账号及其项下的积分及/或资金未经您允许而被第三方盗用。</p>
          <p>3.5 为了防止您及其他用户的用户账号及其项下的个人信息泄露或者被他人窃取，魔鬼鱼（上海）网络科技有限公司可能会随时采取计算机病毒查杀技术、计算机加密技术等措施进行保护。对此，您完全同意并接受，但这并不能免除本协议第3.3条所述的、您对用户账号及其项下的个人信息所负有的妥善保管义务。</p>
          <p>3.6 您如果遗忘了密码或者密码被他人修改，您可以按照魔鬼鱼（上海）网络科技有限公司公布的账号及密码找回规则，通过魔鬼鱼（上海）网络科技有限公司提供的账号及密码找回系统程序进行找回，或者在第一时间联系魔鬼鱼（上海）网络科技有限公司的客服人员协助找回，但魔鬼鱼（上海）网络科技有限公司不保证一定可以找回。</p>
          <p>3.7 您充分理解并完全同意：魔鬼鱼（上海）网络科技有限公司是一家面向消费者的电子商务网站，魔鬼鱼（上海）网络科技有限公司根据您的用户账号下的商品购买记录及其他相关信息，如果发现您此前通过本网站或者魔鬼鱼（上海）网络科技有限公司提供的其他网购渠道购买的商品大多数并非用于个人消费或者使用用途的，对于您的这个用户账号的商品购买需求，魔鬼鱼（上海）网络科技有限公司有权不予接受；您如果已经下达订单，魔鬼鱼（上海）网络科技有限公司有权不予接受订单；魔鬼鱼（上海）网络科技有限公司如果已经接受订单的，有权单方面解除并不予发货。而且，魔鬼鱼（上海）网络科技有限公司视情况还有权冻结您的这个用户账号，使之无法通过本网站以及魔鬼鱼（上海）网络科技有限公司提供的其他网购渠道下达订单、购买商品。</p>
          <p>3.8 作为一个魔鬼鱼（上海）网络科技有限公司的会员，您可以邀请任何一个您的家庭成员、朋友、同事加入本站。这样您就成为他们的邀请人。然而，假如您希望扩大邀请至您家庭成员、朋友、同事等直系圈子以外的人，或者您希望把您的网站链接到本网站，您必须获取魔鬼鱼（上海）网络科技有限公司的预先许可。 在未取得魔鬼鱼（上海）网络科技有限公司事先的书面许可情况下，任何会员通过任何方式组织任何类型的大规模邀请计划，导致不符合前述条款的，将被禁止使用本网站，并且他的个人帐户将被取消。为了防止任何发动自己成为会员的企图，最多两个不同的会员可以使用同一个住所地址。</p>

          <br />
          <h2>4.商品描述与营销信息</h2>
          <p>4.1 商品描述：除非魔鬼鱼（上海）网络科技有限公司或者本网站另有说明，本网站出售的商品均为正宗的商品。魔鬼鱼（上海）网络科技有限公司直接与品牌供应商及其授权的经销商合作开展各项营销活动，相关商品信息均由品牌供应商及/或其授权的经销商提供，魔鬼鱼（上海）网络科技有限公司尽可能根据所接收到的商品信息准确、详尽地描述每一件商品。然而，由于品牌供应商及/或其授权的经销商所提供的商品不一定是准确、完整、可靠、有效和没有错误的，因此魔鬼鱼（上海）网络科技有限公司不能保证本网站所有商品的描述和其他相关内容是准确、完整、可靠、有效和没有错误的。</p>
          <p>4.2 营销信息：您一经注册用户账号，即视为您同意魔鬼鱼（上海）网络科技有限公司及/或其关联公司通过短信或者电子邮件的方式向您注册时填写的手机号码或者电子邮箱发送相应的商品广告信息、促销优惠等营销信息；您如果不同意发送，您可以通过相应的退订功能进行退订。</p>
          <br />
          <h2>5.商品价格</h2>
          <p>本网站上显示的所有价格都是以人民币为计价单位，包括所有的税费，但不包括运费。结帐之前运费会自动计算包含在订单总价之内。在商品详情页面里您可以找到所有的相关信息，支付价格为下订单时的有效价格。</p>

          <br />
          <h2>6.订单</h2>
          <p>6.1 魔鬼鱼（上海）网络科技有限公司保留对单个商品的总出售数量进行限制、对单个订单的商品购买数量及同一IP地址对同类商品购买数量进行限制的权利。</p>
          <p>6.2 根据您填写的订单信息，系统将会生成一份包含您的订单的所有必要信息的电子订单表格。在结帐的过程中，您将被邀请复查订购商品的信息、付款方式以及这些商品的运输方式和费用。依据这些信息生成的最终订单表格被认为是该次交易的有效证据，这份文件被认为是所有的发货、问题、退货和争议事项的参考，所以您必须非常仔细地复查这些信息并纠正一切可能的错误。点击“完成”意味着您认可订单表格中包含的所有信息都是正确和完整的。</p>
          <p>6.3 如果您填写的收货人与用户本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。</p>

          <br />
          <h2>7.取消订单</h2>
          <p>7.1 如您需修改订单请在下单后一小时内自助网上修改（包括合并订单），如订单显示“订单已审核”将不能再进行修改。</p>
          <p>7.2 您也可以选择取消订单，对反复的取消行为，我们可能会调查其原因，也可能会成为我们可能拒绝向您提供服务、冻结或关闭您的个人帐户的原因。</p>

          <br />
          <h2>8.合同成立</h2>
          <p>您通过本网站下达了订单后，仅表示系统接收到了您下单的订单，只有魔鬼鱼（上海）网络科技有限公司将订单上的商品向您发出时，双方之间的买卖合同才成立。而且，如果您在一份订单里订购了多种商品并且魔鬼鱼（上海）网络科技有限公司只给您发出了部分商品时，您与魔鬼鱼（上海）网络科技有限公司之间仅仅就魔鬼鱼（上海）网络科技有限公司已经发出的那一部分商品成立买卖合同。</p>

          <br />
          <h2>9.商品缺货</h2>
          <p>魔鬼鱼（上海）网络科技有限公司接收到您的订单以后，魔鬼鱼（上海）网络科技有限公司发现所订购的商品全部或部分缺货。在这种情况下，魔鬼鱼（上海）网络科技有限公司会就缺货的商品详细情况与您联系，并提供您选择的机会来取消整个订单或用代替商品来替换缺货的物品来变更订单。如果您在收到此类通知15天之内没有取消订单，魔鬼鱼（上海）网络科技有限公司将把有货的商品送达或者在没有一件订购的商品有货的情况下取消该订单。在任何情况下，由于商品的缺货对您或第三方带来的任何损失，魔鬼鱼（上海）网络科技有限公司不负任何责任。</p>

          <br />
          <h2>10.配送服务</h2>
          <p>您所订购的商品有两种配送方式：（1）由魔鬼鱼（上海）网络科技有限公司选择具有运输服务资质的公司为您提供运输代理服务；（2）由品牌供应商选择具有提供运输服务资质的公司为您提供运输代理服务。上述任一配送方式下，您确认并同意一旦魔鬼鱼（上海）网络科技有限公司或者品牌供应商向运输代理服务公司交付你订购的商品，意味着您与提供运输代理服务公司签订了运输代理协议，形成了运输代理合同法律关系； 相关商品灭失及毁损风险自商品交付至运输代理服务公司起转移给您。</p>

          <br />
          <h2>11.交货</h2>
          <p>11.1 您所订购的商品将被送至订单表格上注明的送货地址。无论什么原因商品不能送达到送货地址的，魔鬼鱼（上海）网络科技有限公司将会尽快跟您取得联系。假如从我们第一次试图跟您联系之日7天内您没有提供答复，魔鬼鱼（上海）网络科技有限公司有权取消该订单。</p>
          <p>11.2 在您收到订购商品的同时，请您书面签收证明您收到了完好状态的商品。如果包装出现破损，请拒收。</p>
          <p>11.3 如果送货单中的商品列表与您的订单表格中所记录的不同，或者您收到的商品与送货单中的商品列表不符，您可以按照魔鬼鱼（上海）网络科技有限公司对外公布且正在实施的退货政策及退货程序，将相应的商品退回魔鬼鱼（上海）网络科技有限公司或者魔鬼鱼（上海）网络科技有限公司指定的第三方。而且，您务必于收到所订购的商品之日起7天内，通过发送电子邮件至<a href="mailto:service@10000pets.com">service@10000pets.com</a>或致电()将上述情况告知魔鬼鱼（上海）网络科技有限公司；否则，魔鬼鱼（上海）网络科技有限公司有权不予退货。</p>

          <br />
          <h2>12.付款及所有权</h2>
          <p>魔鬼鱼（上海）网络科技有限公司通过本网站对外销售的商品，如果在魔鬼鱼（上海）网络科技有限公司将商品交付第三方承运人运输之时：</p>
          <p>（1）您已经支付商品的全额的购买价款的，则其所有权于魔鬼鱼（上海）网络科技有限公司将其交付第三方承运人之时转移至您的名下；</p>
          <p>（2）您尚未支付商品的全额的购买价款的，则其所有权于您支付全额的购买价款之时转移至您的名下。</p>
          <p>在商品所有权按照前款约定转移至您的名下之前，商品所有权由魔鬼鱼（上海）网络科技有限公司、品牌供应商或其授权的经销商所有。</p>

          <br />
          <h2>13.商品保证</h2>
          <p>本网站所展示的商品完全符合中华人民共和国的相关法律法规的规定。魔鬼鱼（上海）网络科技有限公司为了保证本网站所售商品的品牌均为正品，特在中国太平洋财产保险股份有限公司（下称“太平洋保险公司”）为魔鬼鱼（上海）网络科技有限公司上售卖的每一件商品进行承保。如果您对在本网站所购买的商品品牌存在怀疑，只需要在收到商品的90天内，凭工商部门的有效鉴定报告，即可向太平洋保险公司索取等同该商品售价的全额赔偿。</p>

          <br />
          <h2>14.知识产权</h2>
          <p>14.1 魔鬼鱼（上海）网络科技有限公司对本网站的内容享有全部知识产权，包括但不限于：编码、商标、服务标志、商号、图形、美术品、照片、肖像、文字内容、音频片断、按钮图标已及计算机软件、标识、数码下载、数据汇编都是魔鬼鱼（上海）网络科技有限公司或其内容提供者的财产，受到中华人民共和国版权相关法律法规的保护。您对其仅享有本协议约定范围内的临时的、可撤销的非专有使用权。</p>
          <p>14.2 您仅在符合本网站使用目的的前提下被许可浏览和使用本网站，即以个人名义浏览信息和购买供个人使用商品的目的。其他方式的使用都是被严格禁止的，包括但不限于以下方式：复制、修改、销售、传送、再版、删除、添加、展览、记入或演示本网站的内容或以其他方式部分地或整体地非法使用本网站的内容，但经魔鬼鱼（上海）网络科技有限公司允许将本网站当中的资讯转发至微信朋友圈等第三方媒体的除外。</p>

          <br />
          <h2>15.用户守则</h2>
          <p>15.1 本网站与其他在线使用的互联网网站一样，您如果需要进行下载、安装、运行、登录或者使用，您至少必须自备一部可供上网的智能移动终端，并确保其能够通过互联网与本网站服务器软件进行实时的信息（即电子数据）交互，相应的上网流量费等相关费用由您自行承担。除非另有说明，魔鬼鱼（上海）网络科技有限公司存储在其服务器上的数据是魔鬼鱼（上海）网络科技有限公司和其会员之间交易的唯一有效证据。</p>
          <p>15.2 本网站目前属于免费使用的网站，魔鬼鱼（上海）网络科技有限公司有权对本网站进行升级及更新，自行设置收费的软件功能、费率标准、收费对象及/或收费时段。您如果不同意魔鬼鱼（上海）网络科技有限公司设置的软件功能、费率标准、收费对象及/或收费时段的，则应当立即停止使用本网站；您如果继续使用的，则视为您接受魔鬼鱼（上海）网络科技有限公司的上述设置，您应当遵照履行并向魔鬼鱼（上海）网络科技有限公司支付相应的费用。</p>
          <p>15.3 您不得进行任何侵犯本网站知识产权的行为，或者进行其他的有损于魔鬼鱼（上海）网络科技有限公司或其他用户合法权益的行为，包括但不限于：</p>
          <p>（1）删除或修改本网站上的版权信息；</p>
          <p>（2）修改、复制和/或发行本网站；</p>
          <p>（3）在本网站当中内置各种插件程序或者其他的第三方程序；</p>
          <p>（4）进行编译、反编译、反向工程或者以其他方式破解本网站的行为；</p>
          <p>（5）使用本网站外挂和/或利用本网站当中的BUG来获得不正当的利益；</p>
          <p>（6）利用劫持域名服务器等技术非法侵入、破坏本网站的服务器软件系统，或者修改、增加、删除、窃取、截留、替换本网站的客户端和/或服务器软件系统中的数据，或者非法挤占本网站的服务器空间，或者实施其他的使之超负荷运行的行为；</p>
          <p>（7）假冒魔鬼鱼（上海）网络科技有限公司或签约商家在本网站当中发布任何诈骗或虚假信息；</p>
          <p>（8）利用本网站故意传播恶意程序或计算机病毒。</p>
          <p>15.4 您充分理解到：魔鬼鱼（上海）网络科技有限公司可能会不定期地通过发布软件升级包或软件补丁、在线升级等方式对本网站进行更新。更新的过程中，魔鬼鱼（上海）网络科技有限公司可能通过互联网调取、收集您的PC端终端上的关于本网站的客户端软件版本信息、数据及其他有关资料，并自动进行替换、修改、删除和/或补充。此种行为是网站更新所必须的一种操作或步骤，您如果不同意魔鬼鱼（上海）网络科技有限公司进行此种操作，请您不要进行更新；您更新的行为即视为您同意魔鬼鱼（上海）网络科技有限公司进行此种操作。</p>
          <p>15.5 您有权在本网站当中发表评论，转发或者回复其他用户的评论，但您应确保评论真实、客观且不会侵犯任何第三方的著作权、肖像权、名誉权、隐私权等合法权利。而且，您不得借助本网站用户评论功能发布任何广告。</p>
          <p>15.6 您应当遵守国家有关法律法规，不得在本网站当中发表、转发或者传播含有下列内容的信息：</p>
          <p>（1）反对宪法所确定的基本原则的；</p>
          <p>（2）危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的；</p>
          <p>（3）损害国家荣誉和利益的；</p>
          <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
          <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
          <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
          <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
          <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
          <p>（9）含有法律、行政法规禁止的其他内容的。</p>
          <p>15.7 个人账户是魔鬼鱼（上海）网络科技有限公司授权您使用魔鬼鱼（上海）网络科技有限公司网站用户管理系统的唯一凭证。魔鬼鱼（上海）网络科技有限公司所提供的代金券、积分、折扣、推送等服务和优惠均通过用户管理系统发放，并且仅提供给获得授权的用户个人使用。您同意在符合法律法规及本条款规定的情况下使用个人帐户，魔鬼鱼（上海）网络科技有限公司有可能在某些情况（例如：您违反本条款和/或其它公开规则，或者您严重违背社会公德、提供虚假注册身份信息或者有其他违反法律禁止性规定的行为或损害魔鬼鱼（上海）网络科技有限公司利益的不正当行为等）下暂时冻结、永久冻结、修改、删除您的个人账户或者采取其他处理措施。特别地，您了解并同意，魔鬼鱼（上海）网络科技有限公司用户管理系统中个人帐户、积分、代金券等互联网产品及服务所有权归属魔鬼鱼（上海）网络科技有限公司，会员在满足魔鬼鱼（上海）网络科技有限公司公布的规则的前提下有权使用上述产品及服务。非经魔鬼鱼（上海）网络科技有限公司同意，您不得将魔鬼鱼（上海）网络科技有限公司各项产品及服务用于商业用途（例如：销售魔鬼鱼（上海）网络科技有限公司个人帐户、销售个人帐户下积分、代金券等）。在使用魔鬼鱼（上海）网络科技有限公司服务过程中，如果您或您的个人帐户刻意规避魔鬼鱼（上海）网络科技有限公司管理措施，或存在涉嫌欺诈、商业牟利、不恰当或不诚实地使用服务或者其他违反本条款和/或其他公开规则的行为（包括但不限于使用作弊软件获取积分及/或代金券、贩卖个人帐号、积分及/或代金券、盗号、协助盗号、非用于个人或家庭的合理消费等），魔鬼鱼（上海）网络科技有限公司有权拒绝为您继续提供服务，永久冻结您的个人帐户，并根据具体情况并有权对该等个人帐号中因上述手段而产生、获得的一切虚拟产品予以清零。</p>

          <br />
          <h2>16.免责声明</h2>
          <p>16.1 关于本网站的免责声明</p>
          <p>16.1.1 本网站与其他的在线使用的互联网网站一样，也会受到各种不良信息、网络安全和网络故障问题的困扰，包括但不限于：</p>
          <p>（1）其他用户可能会发布诈骗或虚假信息，或者发表有谩骂、诅咒、诋毁、攻击内容的，或者含有淫秽、色情、下流、反动、煽动民族仇恨等让人反感、厌恶的内容的非法言论；</p>
          <p>（2）其他用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私权和/或其他合法权益的图片、照片、文字等资料；</p>
          <p>（3）面临着诸如黑客攻击、计算机病毒困扰、系统崩溃、网络掉线、网速缓慢、程序漏洞等问题的困扰和威胁。</p>
          <p>16.1.2 您充分理解到：本协议第17.1.1条所述的各种不良信息、网络安全和网络故障问题，并不是魔鬼鱼（上海）网络科技有限公司或者本网站所导致的问题，由此可能会造成您感到反感、恶心、呕吐等精神损害，或者给您造成其他的损失，概由您自行承担，魔鬼鱼（上海）网络科技有限公司无须向您承担任何责任。</p>
          <p>16.1.3 您完全同意：除法律法规规定或者您与魔鬼鱼（上海）网络科技有限公司约定须提前通知的以外，魔鬼鱼（上海）网络科技有限公司有权单方面地中止或者终止本网站所提供的服务而无须提前通知您。该等中止、终止，可能是因为魔鬼鱼（上海）网络科技有限公司解散、注销、合并、分立，也可能是因为魔鬼鱼（上海）网络科技有限公司将本网站或其运营权转让给了第三方，还可能是因为国家法律、法规、政策及国家机关的命令或者其他的诸如地震、火灾、海啸、台风、罢工、战争等不可抗力事件，还可能是因为您违反本协议第15.3条和/或第15.5条所约定的用户守则。</p>
          <p>16.2 关于商品销售的免责声明</p>
          <p>16.2.1 由于用不同手机终端设备观看时网页显示的差异，魔鬼鱼（上海）网络科技有限公司上促销的商品在图像和颜色方面可能跟真实的物品不尽一致。因此，所有显示的图片、视频和其他商品显示方法仅限于图示目的，在任何情况下不认为是合同的组成部分。假如供出售的商品跟网站上的描述不同，对您唯一的补救措施是根据本协议在没有使用的情况下退回该商品。</p>
          <p>16.2.2 魔鬼鱼（上海）网络科技有限公司保留根据市场价格波动随时修改上线商品价格的权利而无须事先通知。在由于排版错误或供应商提供价格信息错误的情况下以不正确的价格列出来的商品，魔鬼鱼（上海）网络科技有限公司有拒绝或取消任何对以不正确的价格列出来的商品所下订单的权利。</p>
          <p>16.2.3 由于合理的或不可避免的送货延迟对您或第三方带来的任何损失，魔鬼鱼（上海）网络科技有限公司不负任何责任。在这种情况下，魔鬼鱼（上海）网络科技有限公司将尽快地把任何可预知的延迟情况通知您，并在此时请您选择是否取消订单。</p>
          <p>16.2.4 魔鬼鱼（上海）网络科技有限公司上面陈列的货物完全符合中华人民共和国的相关法律法规的规定。魔鬼鱼（上海）网络科技有限公司直接与品牌供应商或者他们授权的经销商合作，他们保证其商品是正宗的。您在魔鬼鱼（上海）网络科技有限公司上找到的商品描述均由品牌供应商或者他们授权的经销商提供，仅由他们对其真实性负责。您应该系统性地参照货物描述找出他们的特征，对于任何种类的直接或间接的、实质或非实质的由于商品的使用造成的损失，魔鬼鱼（上海）网络科技有限公司概不负责。</p>

          <br />
          <h2>17.个人信息保护</h2>
          <p>17.1 魔鬼鱼（上海）网络科技有限公司可能通过本网站 在您自愿选择服务或提供信息的情况下收集您的个人信息（简称“个人信息”），例如您的姓名、邮件地址、电话号码及其他身份信息等。我们有可能会保留一些用户的使用习惯信息，用于更好地了解和服务于用户。这些数据将有利于我们开发出更符合用户需求的功能、信息和服务。</p>
          <p>17.2 魔鬼鱼（上海）网络科技有限公司通过本网站可能会收集一些特定的关于您所使用的机器的技术信息，可能会包括：IP地址、操作系统版本、浏览器版本、显示器分辨率、推荐网站等。这些信息将用于提供更好的用户使用体验，提供更方便的服务。</p>
          <p>17.3 魔鬼鱼（上海）网络科技有限公司非常重视保护您的魔鬼鱼（上海）网络科技有限公司账号及密码、电话号码、地理位置、智能移动终端品牌及型号等个人信息，未经您同意，魔鬼鱼（上海）网络科技有限公司不会将其披露给无关的第三方，更不会将其公之于众，但因下列原因而披露给第三方的除外：</p>
          <p>（1）基于国家法律法规的规定而对外披露；</p>
          <p>（2）应国家司法机关及其他有关机关基于法定程序的要求而披露；</p>
          <p>（3）为保护魔鬼鱼（上海）网络科技有限公司或您的合法权益而披露；</p>
          <p>（4）在紧急情况，为保护其他用户及第三方人身安全而披露；</p>
          <p>（5）经您本人同意或应您的要求而披露。</p>
          <p>17.4 魔鬼鱼（上海）网络科技有限公司将使用各种安全技术和程序防止您及其他用户个人信息的丢失、不当使用、未经授权阅览或披露。但您充分理解到：由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。</p>

          <br />
          <h2>18.其他约定</h2>
          <p>18.1 魔鬼鱼（上海）网络科技有限公司保留随时地、不事先通知地、不需要任何理由地、单方面地修订本协议的权利。本协议一经修订，魔鬼鱼（上海）网络科技有限公司将会用修订后的协议版本完全替代修订前的协议版本，并通过适当的方式向所有用户公布。您应当及时关注和了解本协议的修订情况，如果您不同意修订后协议版本，请您立即停止使用本网站，否则即视同您同意并完全接受修订后的协议版本。</p>
          <p>18.2 魔鬼鱼（上海）网络科技有限公司有可能以消费者告知书、买家须知、温馨提示等形式，向您说明您在使用本网站购买商品时应当履行的本协议所约定的义务之外的其他义务，您亦应当仔细阅读并全面履行。上述说明如果与本协议相互冲突或者矛盾的，以上述约定为准；上述约定未涉及的内容，仍适用本协议。</p>
          <p>18.3 魔鬼鱼（上海）网络科技有限公司将本协议内置于本网站的注册环节，您在注册的过程中即可查阅、了解本协议，并通过勾选“我已阅读并接受魔鬼鱼（上海）网络科技有限公司服务条款”表示您完全同意并接受本协议之约束，或者通过取消勾选“我已阅读并接受魔鬼鱼（上海）网络科技有限公司服务条款”表示您不同意本协议。</p>
          <p>18.4 本协议各条款是可分的，所约定的任何条款如果部分或者全部无效，不影响该条款其他部分及本协议其他条款的法律效力。</p>
          <p>18.5 本协议各条款的标题只是为了方便用户阅读而起到提示、醒目的作用，对本协议的解释及适用没有任何指引作用。</p>
          <p>18.6 魔鬼鱼（上海）网络科技有限公司基于本协议及其补充协议的有效弃权必须是书面的，并且该弃权不能产生连带的相同或者类似的弃权。</p>
          <p>18.7 您通过本网站购买非商品的服务产品（例如旅游产品）的，您与魔鬼鱼（上海）网络科技有限公司之间的权利义务亦参照本协议的相关约定。</p>
          <p>18.8 您与魔鬼鱼（上海）网络科技有限公司均应当严格履行本协议及其补充协议所约定的各项义务，如发生争议或者纠纷，双方可以友好协商解决；协商不成的，任何一方均可提请魔鬼鱼（上海）网络科技有限公司办公所在地诉讼解决。</p>

          <br />
          <p>魔鬼鱼（上海）网络科技有限公司</p>
          <p>二〇二零年十一月</p>
        </div>
        <nav style={{ textAlign: 'center', padding: '20px 0' }}>
          <a href="/" style={{ color: '#5938E3' }}>← 返回首页</a>
        </nav>
      </article>
    </Layout>
  );
};

export default Protocol;
